import type { TimelineBoardKey } from '../types/schema'

const BOARD_PATTERNS: Array<[TimelineBoardKey, RegExp]> = [
  ['VISIONBOARD', /\b(?:in|on|to|into|within|under)\s+(?:the\s+)?vision\s*board\b/i],
  ['DASHBOARD', /\b(?:in|on|to|into|within|under)\s+(?:the\s+)?dashboard\b/i],
  ['ARCHIVE', /\b(?:in|on|to|into|within|under)\s+(?:the\s+)?archive\b/i],
  ['BIN', /\b(?:in|on|to|into|within|under)\s+(?:the\s+)?(?:bin|trash)\b/i],
]

export const resolveAiTargetBoard = (request: string, fallback: TimelineBoardKey): TimelineBoardKey =>
  BOARD_PATTERNS.find(([, pattern]) => pattern.test(request))?.[0] ?? fallback
